import { OperationStatus } from '@pressreader/appstore';

const statusCodes = {
    accepted: 202,
    created: 201,
    ok: 200,
};

const snippetRenderStatusByCode: {
    [key: number]: OperationStatus;
} = {
    202: OperationStatus.Pending,
    201: OperationStatus.Done,
    200: OperationStatus.Pending,
};

export { statusCodes, snippetRenderStatusByCode };
